import React from "react";
import { Box, TextField } from "@mui/material";

const SideBySide = ({ data, image, onTextFieldChange, width }) => {
  let leftPaneWidth = width + "%";
  let rightPaneWidth = 100 - width + "%";
  return (
    <>
      <Box sx={{ width: leftPaneWidth }}>
        <TextField
          id="outlined-multiline-fixed"
          label="Sequence diagram UML"
          multiline
          value={data}
          maxRows={Math.max(30, (40 * (100 - width)) / 100)}
          style={{ width: "100%" }}
          onChange={onTextFieldChange}
        />
      </Box>
      <Box sx={{ width: rightPaneWidth }}>
        <img
          src={image}
          alt="Diagram"
          style={{ maxWidth: "100%", height: "100%" }}
        />
      </Box>
    </>
  );
};

export default SideBySide;
